import React from "react";
import "../App.css";
import { Box, Container, Grid, Typography } from "@mui/material";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import GavelIcon from "@mui/icons-material/Gavel";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import GibWidget from "../components/GibWidget";
import TurmobWidget from "../components/TurmobWidget";
import ImageSlider from "../components/ImageSlider";

const services = [
    {
        title: "Şirket Kuruluş Hizmetleri",
        description:
            "Mükelleflerimiz için en uygun şirket türünü belirler, eksiksiz olarak gerekli belgeleri düzenler, şirketin yasal olarak kurulmasından, gerekli odalara ve ticaret siciline kaydedilmesine kadar tüm süreçleri yönetiriz.",
        icon: <BusinessCenterIcon fontSize="large" color="primary" />,
    },
    {
        title: "Muhasebe Ve Mali Müşavirlik Hizmetleri",
        description:
            "Vergi Usul Kanununa uygun olarak resmi defterlerin tutulması, bordroların yönetimi, SGK işlemleri, bilanço, gelir tablosu ve diğer mali tablolar düzenlemek gibi birçok mali hizmetler sunmaktayız.",
        icon: <ReceiptLongIcon fontSize="large" color="primary" />,
    },
    {
        title: "Mali Danışmanlık Hizmetleri",
        description:
            "Her türlü vergi danışmanlığı, mali hukuk danışmanlığı, uluslararası vergi hizmetleri danışmanlığı, teşvik uygulama ve destek danışmanlığı gibi her türlü mali konularda danışmanlık hizmetleri vermekteyiz.",
        icon: <GavelIcon fontSize="large" color="primary" />,
    },
    {
        title: "Bordrolama Ve Personel Hizmetleri",
        description:
            "İşe giriş ve çıkış bildirgelerinin hazırlanması, SGK aylık bildirgelerinin yapılması, ücret bordrolarının hazırlanması, iş sözleşmelerinin hazırlanması ve saklanması, şirket çalışanlarının SGK teşviklerinin sorgulanması vb. hizmetler.",
        icon: <PeopleAltIcon fontSize="large" color="primary" />,
    },
    {
        title: "Yönetim ve Denetim Hizmetleri",
        description:
            "Genel muhasebesini kendi bünyesinde tutan şirketlerin muhasebe sisteminin kurulması, kontrol edilmesi, beyanname, bordro ve raporların oluşturulması, hesapların düzenli olarak denetlenmesi hizmetlerini içermektedir.",
        icon: <VerifiedUserIcon fontSize="large" color="primary" />,
    },
    {
        title: "Yapılandırma, Teşvik ve Hibe Danışmanlığı",
        description:
            "Vergi mükellefi müşterilerimizin vergi risklerini yönetmesine yönelik yapılandırma ve teşvikler hakkında bilgilendirmesi, süreci yönetme, en güncel hibe ve destek programları hakkında bilgilendirmesi ve başvuru hizmetleri vb.",
        icon: <AttachMoneyIcon fontSize="large" color="primary" />,
    },
];

const Homepage = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "column" }, alignItems: "center", justifyContent: "center", textAlign: "center", py: 3 }}>

            <Box
                sx={{
                    display: "flex",
                    gap: 5,
                    justifyContent: "center",

                }}
            >
                <Box sx={{ width: "100%", display: { xs: 'none', md: 'flex'} }}>
                    <TurmobWidget />
                </Box>
                <Box sx={{ width: "100%", display: { xs: 'flex', md: 'flex'} }}>
                    <ImageSlider />
                </Box>
                <Box sx={{ width: "100%", display: { xs: 'none', md: 'flex'} }}>
                    <GibWidget />
                </Box>
            </Box>

            <Box sx={{ width: "100%", display: { xs: 'flex', md: 'none'}, justifyContent: "center", mt: 4 }}>
                <TurmobWidget />
            </Box>

            <Box sx={{ width: "100%", display: { xs: 'flex', md: 'none'}, justifyContent: "center", mt: 4 }}>
                <GibWidget />
            </Box>
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Neler Yapıyoruz?
                </Typography>
                <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                    "Muhasebede Uzmanlık, Finansal Başarıda Güvence."
                </Typography>
                <Container maxWidth="lg">
                    <Grid container spacing={4} justifyContent="center">
                        {services.map((service, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Box sx={{ p: 3, textAlign: "center" }}>
                                    {service.icon}
                                    <Typography variant="h6" fontWeight="bold" sx={{ mt: 2 }}>
                                        {service.title}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        {service.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};


export default Homepage;